<template>
  <tr class="tr-nohover">
    <td>{{props.index}}</td>
    <template v-if="item.work != 'returning_warehouse'">
      <td>
        <div class='d-flex flex-column '>
          <select class="border work-table-input-box" v-model="item.work">
            <template v-for="(value, name) in SELECT_WORK_EVENT_TYPES" :key="'work_type_' + value">
              <option :value="name">{{value}}</option>
            </template>
          </select>
          <small v-for="(message, i) in errors?.work ?? []" class="text-danger" :key="'error-work-'+i">{{message}}</small>
        </div>
      </td>
    </template>
    <template v-else>
      <td>{{SELECT_WORK_EVENT_TYPES[item.work]}}</td>
    </template>
    <td>
      <div class='d-flex flex-column'>
        <input class="border work-table-input-box" v-model="item.spot_name" />
        <small v-for="(message, i) in errors?.spot_name ?? []" class="text-danger" :key="'error-work-'+i">{{message}}</small>
      </div>
    </td>
    <td>
      <VueDatePicker
        class=""
        :clearable="false"
        v-model="item.start_time"
        :locale="ja"
        :formats="{ input: 'yyyy-MM-dd HH:mm:ss' }"
        :enableSeconds="true"
        :time-config="{ enableSeconds: true }"
      />
      <small v-for="(message, i) in errors?.start_time ?? []" class="text-danger" :key="'error-work-'+i">{{message}}</small>
    </td>
    <template v-if="item.work != 'returning_warehouse'">
      <td>
        <VueDatePicker
          class=""
          :clearable="false"
          v-model="item.end_time"
          :locale="ja"
          :formats="{ input: 'yyyy-MM-dd HH:mm:ss' }"
          :enableSeconds="true"
          :time-config="{ enableSeconds: true }"
        />
        <small v-for="(message, i) in errors?.end_time ?? []" class="text-danger" :key="'error-work-'+i">{{message}}</small>
      </td>
    </template>
    <template v-else>
      <td></td>
    </template>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td>
      <button
        class="update-dailyreport-button undo-button"
        @click="undo">
        <span class="material-symbols-outlined">
          undo
        </span>
      </button>
    </td>
    <td>
      <button
        class="update-dailyreport-button save-button"
        @click="save"
      >
        <span class="material-symbols-outlined">
          save
        </span>
      </button>
      <button
        class="update-dailyreport-button delete-button"
        v-if="item.work != 'leaving_warehouse' && item.adding"
        @click="remove"
      >
        <span class="material-symbols-outlined">
          delete
        </span>
      </button>
    </td>
  </tr>
  <tr
    v-if="item.work == 'returning_warehouse'"
  >
    <td></td>
    <td></td>
    <td></td>
    <td colspan=2>
      <label
        class="text-black-75"
      >
        {{getSelectableRangeMessage(item)}}
      </label>
    </td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
</template>

<script lang="ts" setup>

import { ref } from "vue";
import {
  SELECT_WORK_EVENT_TYPES
} from "@/services/consts";
import DeliveryPlanEvent from '@/services/models/DeliveryPlanEvent'
import DeliveryPlanEventType from "@/types/DeliveryPlanEvent"
import Workload from '@/services/models/Workload'
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ja } from 'date-fns/locale'
import i18n from '@/lang/i18n';

const props = defineProps({
  modelValue: {},
  index: { type: Number },
})

const emits = defineEmits([
  "update:modelValue",
  "remove",
  "save",
]);
const errors = ref({});
const beforeItem = structuredClone(props.modelValue);
const stoppingPeriods = ref([]);

const item = ref(props.modelValue);

function remove() {
  emits('remove');
}

function save() {
  if (validate()) {
    item.value.edited_at = new Date().toLocaleTimeString()
    if (item.value.works[0] && item.value.works[1]) {
      Workload.generateWorkId(item.value.delivery_plan_id, item.value.work, true, item.value.start_time)
      .then((digestHex) => {
        item.value.works[0].work_id = digestHex
      });
      Workload.generateWorkId(item.value.delivery_plan_id, item.value.work, false, item.value.end_time)
      .then((digestHex) => {
        item.value.works[1].work_id = digestHex
      });
    }
    item.value.editing = false;
    emits('update:modelValue', item.value);
    emits('save');
  }
}

function undo() {
  Object.assign(item.value, structuredClone(beforeItem));
  item.value.editing = false;
  errors.value = {};
  emits('update:modelValue', item.value);
}

function validate() {
  let isValid = true
  const errs = DeliveryPlanEvent.validate(item.value, beforeItem, stoppingPeriods.value)
  if (errs) {
    isValid = false
  }
  errors.value = errs ?? {}
  return isValid
}

function getSelectableRangeMessage(item: DeliveryPlanEventType) {
  if (item.before_end == item.after_start) {
    return i18n.global.t('pages.dailyReports.updateModal.messages.notChange')
  }
  return i18n.global.t('pages.dailyReports.updateModal.workList.selectableRange') + ': ' +
    item.before_end + '~' + item.after_start
}
</script>
